export const addHero = (hero) => {
  const title = document.querySelector('[data-project-hero-title]');
  const image = document.querySelector('[data-project-hero-image]');

  title.innerHTML = hero.title;
  image.setAttribute('data-src', hero.image)
  image.setAttribute('alt', hero.title)
}